import type { CSSProperties } from "react";

export const DEFAULT_LOGO_SCALE = 100;
export const MIN_LOGO_SCALE = 75;
export const MAX_LOGO_SCALE = 200;

export function getBrandLogoScale(value: unknown): number {
  const parsed = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(parsed)) return DEFAULT_LOGO_SCALE;
  return Math.min(MAX_LOGO_SCALE, Math.max(MIN_LOGO_SCALE, Math.round(parsed)));
}

export function getBrandLogoStyle(value: unknown): CSSProperties {
  return { "--brand-logo-scale": String(getBrandLogoScale(value) / 100) } as CSSProperties;
}

export function getEmailLogoSize(value: unknown, baseHeight = 48, baseWidth = 200) {
  const ratio = getBrandLogoScale(value) / 100;
  return {
    height: Math.round(baseHeight * ratio),
    width: Math.round(baseWidth * ratio),
  };
}